/**
 * TBS Scroll Animations
 * Fade + slide-up effect on product cards as they scroll into view
 * Uses native Intersection Observer — no libraries required
 */

(function () {
  // Respect user's reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const SELECTORS = [
    '.card-wrapper',
    '.collection-list__item',
    '.tbs-logo-bar__item',
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tbs-animate--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observeElements() {
    SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el, index) => {
        // Stagger delay based on position in row (max 4 items per row)
        const delay = (index % 4) * 80;
        el.style.transitionDelay = `${delay}ms`;
        el.classList.add('tbs-animate');
        observer.observe(el);
      });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  // Re-run when Shopify renders new content (infinite scroll, filters etc.)
  document.addEventListener('shopify:section:load', observeElements);
})();
